// Mock auth functions to replace NextAuth in React
import { useSelector } from 'react-redux'
import type { RootState } from '@/store'

export function useSession() {
  const auth = useSelector((state: RootState) => state.auth)

  if (auth.userId && auth.accessToken) {
    return {
      data: {
        user: {
          id: auth.userId,
          name: auth.userName || 'User',
          email: auth.email || 'user@example.com',
          role: auth.userType || 'developer'
        }
      },
      status: 'authenticated'
    }
  }

  return {
    data: null,
    status: 'unauthenticated'
  }
}

export function signOut(options?: { callbackUrl?: string }) {
  // Clear local storage
  localStorage.removeItem('authToken')
  localStorage.removeItem('userId')

  // Redirect to login
  window.location.href = options?.callbackUrl || '/login'
}